import { NetworkStatus } from "@apollo/client";
import { useQuery } from "@apollo/client/react";
import { GetUserBrandDocument, UserBrandsDocument } from "@repo/graphql/documents/brand/query.generated";
import { useCallback, useMemo } from "react";

const PAGE_SIZE = 100;

export const useSelectedBrand = (brandId?: string) => {
  const { data, loading, fetchMore, networkStatus, error, refetch } = useQuery(
    UserBrandsDocument,
    {
      variables: {
        orderBy: "brand_Name",
        first: PAGE_SIZE,
        myUserBrands: true,
      },
      notifyOnNetworkStatusChange: true,
    },
  );
  const { data: brandData, loading: selectedBrandDataLoading } = useQuery(
    GetUserBrandDocument,
    {
      variables: { brandId: brandId ?? "" },
      skip: !brandId,
    },
  );

  const brands = data?.brand.userBrands?.edges.map((u) => u.node.brand);

  const pageInfo = data?.brand.userBrands?.pageInfo;

  const selectedBrand = brandData?.brand.getUserBrand?.brand;

  const fetchingMore = networkStatus === NetworkStatus.fetchMore;

  const loadMore = useCallback(() => {
    if (!pageInfo?.hasNextPage || fetchingMore) return;
    fetchMore({
      variables: { after: pageInfo.endCursor, first: PAGE_SIZE },
    });
  }, [pageInfo, fetchingMore, fetchMore]);

  const hasNextPage = useMemo(() => pageInfo?.hasNextPage ?? false, [pageInfo]);

  return {
    data,
    brands,
    error,
    loading,
    selectedBrand,
    selectedBrandDataLoading,
    fetchMore,
    loadMore,
    fetchingMore,
    hasNextPage,
    refetch,
    networkStatus,
  };
};
